import classnames from 'classnames';
import React from 'react';

type VerticalListItemProps = {
  disabled?: boolean;
  highlighted?: boolean;
  children: React.ReactNode;
} & React.HTMLAttributes<HTMLDivElement>;

export const VerticalListItem = ({
  className,
  disabled,
  highlighted,
  onClick,
  children,
  ...props
}: VerticalListItemProps): React.ReactElement => {
  const classNames = classnames(className, 'airtame-vertical-list-item', {
    'airtame-vertical-list-item--disabled': disabled,
    'airtame-vertical-list-item--highlighted': highlighted,
  });
  return (
    <div className={classNames} role="listitem" onClick={onClick} {...props}>
      {children}
    </div>
  );
};
